import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';

import
{
  Menu,
  MenuItem,
  MenuButton,
  SubMenu,
  ControlledMenu
} from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';

import HelpIcon from '@material-ui/icons/Help';
import MenuIcon from '@material-ui/icons/Menu';
import ExitToAppOutlined from '@material-ui/icons/ExitToAppOutlined';
import CircleGreen from '../../src/img/circle-green.svg';

import Logo from '../../src/img/procuratio_logo.png';

import { useContext } from 'react';
import { DataContext } from '../context/DataContext';

interface ContainerProps { }

const CompMenu: React.FC<ContainerProps> = () =>
{
  const {
    appInhaltUeberschriftChange,
    appInhaltArtikelChange,

    appMenueItems
  } = useContext( DataContext );

  const ref_unternehmen = useRef( null );
  const ref_az = useRef( null );
  const [ state_unternehmen, setState_unternehmen ] = useState();
  const [ state_az, setState_az ] = useState( '' );

  const [ suchbegriff, setSuchbegriff ] = useState( '' );

  const ref_status = useRef( null );
  const [ state_status, setState_status ] = useState();
  return (
    <div
      style={ {
        width: '100%',
        backgroundColor: '#fff',
        padding: '0px 30px'
      } }
    >
      <div
        style={ {
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
          flexWrap: 'nowrap',
          padding: '20px 0px'
        } }
      >
        <div id="header_name">intranet</div>
        <div>
          { ' ' }
          <Link
            to={ '/' }
            className="a_header"
          >
            <img
              id="kopflogo"
              src={ Logo }
              alt="Procuratio"
            />
          </Link>
        </div>
        <div id="burgermenu">
          <Menu
            menuButton={
              <MenuButton>
                <MenuIcon />
              </MenuButton>
            }
          >
            <MenuItem>
              <Link
                to={ '/' }
                className="a_header"
              >
                start
              </Link>
            </MenuItem>
            <MenuItem>
              <Link
                to={ '/job' }
                className="a_header"
              >
                mein job + ich
              </Link>
            </MenuItem>
            <SubMenu label="Unternehmen">
              <SubMenu label="Organigramme">
                <MenuItem>
                  <Link
                    to={ '/unternehmen' }
                    className="a_header"
                  >
                    Unternehmen
                  </Link>
                </MenuItem>
                <MenuItem>
                  <Link
                    to={ '/unternehmen_catering' }
                    className="a_header"
                  >
                    Catering
                  </Link>
                </MenuItem>
                <MenuItem>
                  <Link
                    to={ '/unternehmen_ur' }
                    className="a_header"
                  >
                    Unterhaltsreinigung
                  </Link>
                </MenuItem>
              </SubMenu>
              <MenuItem>
                <Link
                  to={ '/arbeitsvorlagen' }
                  className="a_header"
                >
                  Arbeitsvorlagen
                </Link>
              </MenuItem>
            </SubMenu>
            <MenuItem>
              <Link
                to={ '/standorte' }
                className="a_header"
              >
                Standorte
              </Link>
            </MenuItem>
            <MenuItem>
              <Link
                to={ '/quality' }
                className="a_header"
              >
                Qualitätsmanagement
              </Link>
            </MenuItem>
            <MenuItem>
              <Link
                to={ '/enkelwirtschaft' }
                className="a_header"
              >
                Enkelwirtschaft
              </Link>
            </MenuItem>

            <MenuItem>
              <Link
                to={ '/links' }
                className="a_header"
              >
                Links
              </Link>
            </MenuItem>
            <MenuItem>
              <Link
                to={ '/suche' }
                className="a_header"
              >
                Suche
              </Link>
            </MenuItem>
          </Menu>
        </div>
        <div id="header_system">
          <div style={ { fontSize: '24px', color: '#55ba5e' } }>
            <a
              className="a_header"
              href={
                'https://intranet-backend.procuratio.com/nc/Intranet/Schulungsunterlagen/IT/Schulung_Cloud_Intranet.pdf'
              }
              target="_blank"
            >
              <HelpIcon
                style={ { fontSize: '30px', color: '#55ba5e' } }
              ></HelpIcon>
            </a>
            <Link
              className="a_header"
              to={ '/logout' }
            >
              <ExitToAppOutlined
                style={ { fontSize: '30px', color: '#55ba5e' } }
              ></ExitToAppOutlined>
            </Link>
          </div>

          <div>
            <Link
              className="a_header"
              ref={ ref_status }
              //@ts-ignore
              onMouseEnter={ () => setState_status( 'open' ) }
              to={ '' }
            >
              systemzustand <img src={ CircleGreen } />
            </Link>
            <ControlledMenu
              style={ { border: 'none' } }
              state={ state_status }
              anchorRef={ ref_status }
              //@ts-ignore
              onMouseLeave={ () => setState_status( 'closed' ) }
              //@ts-ignore
              onClose={ () => setState_status( 'closed' ) }
            >
              <MenuItem>
                <img src={ CircleGreen } />
                Cloud
              </MenuItem>
              <MenuItem>
                <img src={ CircleGreen } />
                E-Mail
              </MenuItem>
              <MenuItem>
                <img src={ CircleGreen } />
                Benutzeranmeldung
              </MenuItem>
              <MenuItem>
                <img src={ CircleGreen } />
                VPN Erkrath
              </MenuItem>
              <MenuItem>
                <img src={ CircleGreen } />
                VPN Mülheim
              </MenuItem>

              <MenuItem>
                <a
                  style={ {
                    color: 'color',
                    textDecoration: 'none',
                    textTransform: 'none'
                  } }
                  href="mailto:support@procuratio.com"
                  className=""
                >
                  Kontaktiere den Support für hier nicht aufgelistete Probleme.
                </a>
              </MenuItem>
            </ControlledMenu>
          </div>
        </div>
      </div>

      <div
        id="header_links"
        style={ {
          flexDirection: 'row',
          justifyContent: 'space-between',
          flexWrap: 'nowrap',
          marginBottom: '20px'
        } }
      >
        <div>
          <Link
            to={ '/' }
            className="a_header"
          >
            start
          </Link>
        </div>
        <div>
          <Link
            to={ '/job' }
            className="a_header"
          >
            mein job + ich
          </Link>
        </div>
        <div>
          <Link
            to={ '/unternehmen' }
            className="a_header"
            ref={ ref_unternehmen }
            //@ts-ignore
            onMouseEnter={ () => setState_unternehmen( 'open' ) }
          >
            Unternehmen
          </Link>
          <ControlledMenu
            state={ state_unternehmen }
            anchorRef={ ref_unternehmen }
            //@ts-ignore
            onMouseLeave={ () => setState_unternehmen( 'closed' ) }
            //@ts-ignore
            onClose={ () => setState_unternehmen( 'closed' ) }
          >
            <SubMenu label="Organigramme">
              <MenuItem>
                <Link
                  to={ '/unternehmen' }
                  className="a_header"
                >
                  Unternehmen
                </Link>
              </MenuItem>
              <MenuItem>
                <Link
                  to={ '/unternehmen_catering' }
                  className="a_header"
                >
                  Catering
                </Link>
              </MenuItem>
              <MenuItem>
                <Link
                  to={ '/unternehmen_ur' }
                  className="a_header"
                >
                  Unterhaltsreinigung
                </Link>
              </MenuItem>
            </SubMenu>
            <MenuItem>
              <Link
                to={ '/arbeitsvorlagen' }
                className="a_header"
              >
                Arbeitsvorlagen
              </Link>
            </MenuItem>
            <MenuItem>
              <Link
                to={ '/enkelwirtschaft' }
                className="a_header"
              >
                Enkelwirtschaft
              </Link>
            </MenuItem>
          </ControlledMenu>
        </div>

        <div>
          <Link
            to={ '/standorte' }
            className="a_header"
          >
            standorte
          </Link>
        </div>
        <div>
          <Link
            to={ '/quality' }
            className="a_header"
          >
            Qualitätsmanagement
          </Link>
        </div>
        <div>
          <Link
            to={ '/enkelwirtschaft' }
            className="a_header"
          >
            Enkelwirtschaft
          </Link>
        </div>
        <div>
          <Link
            to={ '/links' }
            className="a_header"
          >
            Links
          </Link>
        </div>
        <div>
          {/* <input type="text" onKeyUp={ (element) => passToSearch(element.target.value) } placeholder="SUCHE"/> */ }

          <Link
            to={ '/suche' }
            className="a_header"
          >
            Suche
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CompMenu;
